import { Token, TokenType } from ".";
import { LinePosition } from "@wittongue/editor";

export class ControlFlowToken extends Token {
  constructor(key: string, linePosition: LinePosition) {
    super(key, TokenType.CONTROL, linePosition);
  }
}
